export default "__VITE_ASSET__4yBKBZOF__"